export const ROLE_CAPITAN = 'capitanTeam'
export const ROLE_PLAYER = 'playerTeam'
